import './styles.css'
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';

function ContactSection() {
    return (
        <section id="contato" className="py-20 bg-white scroll-mt-16">
            <div className="container mx-auto px-4">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <span className="inline-block bg-red-100 text-red-600 px-4 py-1 rounded-full text-sm font-semibold mb-4">
                        VAMOS CONVERSAR
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Entre em Contato</h2>
                    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                        Estamos prontos para responder suas dúvidas sobre nossas entregas e serviços logísticos.
                    </p>
                    <div className="w-24 h-1 bg-gradient-to-r from-red-600 to-yellow-400 mx-auto mt-6 rounded"></div>
                </div>

                {/* Contact Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
                    {/* Address Card */}
                    <div className="bg-gradient-to-br from-red-50 to-red-100 p-8 rounded-xl border-t-4 border-red-600 hover:shadow-lg transition duration-300 text-center">
                        <div className="flex justify-center mb-4">
                            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-red-600 text-white">
                                <FaMapMarkerAlt size={24} />
                            </div>
                        </div>
                        <h3 className="text-base font-bold text-gray-900 mb-3">Endereço</h3>
                        <p className="text-sm text-gray-600 leading-relaxed">
                            R. Waldemar Rocha, 2804<br/>
                            Parque Ideal<br/>
                            Teresina - PI
                        </p>
                    </div>

                    {/* Phone Card */}
                    <div className="bg-gradient-to-br from-red-50 to-red-100 p-8 rounded-xl border-t-4 border-red-600 hover:shadow-lg transition duration-300 text-center">
                        <div className="flex justify-center mb-4">
                            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-red-600 text-white">
                                <FaPhone size={24} />
                            </div>
                        </div>
                        <h3 className="text-base font-bold text-gray-900 mb-3">Telefone</h3>
                        <p className="text-sm text-gray-600">
                            <a href="tel:+558632364215" className="hover:text-red-600 font-semibold block mb-2">(86) 3236-4215</a>
                            <span className="text-xs text-gray-500">Seg-Sex: 8h às 18h</span>
                        </p>
                    </div>

                    {/* Email Card */}
                    <div className="bg-gradient-to-br from-red-50 to-red-100 p-8 rounded-xl border-t-4 border-red-600 hover:shadow-lg transition duration-300 text-center">
                        <div className="flex justify-center mb-4">
                            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-red-600 text-white">
                                <FaEnvelope size={24} />
                            </div>
                        </div>
                        <h3 className="text-base font-bold text-gray-900 mb-3">E-mail</h3>
                        <p className="text-sm text-gray-600">
                            <a href="mailto:contato@distribuidorayork.com.br" className="hover:text-red-600 font-semibold block mb-2 break-words">contato@distribuidorayork.com.br</a>
                            <span className="text-xs text-gray-500">Resposta rápida</span>
                        </p>
                    </div>

                    {/* WhatsApp Card */}
                    <div className="bg-gradient-to-br from-red-50 to-red-100 p-8 rounded-xl border-t-4 border-red-600 hover:shadow-lg transition duration-300 text-center">
                        <div className="flex justify-center mb-4">
                            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-red-600 text-white">
                                <FaWhatsapp size={24} />
                            </div>
                        </div>
                        <h3 className="text-base font-bold text-gray-900 mb-3">WhatsApp</h3>
                        <p className="text-sm text-gray-600">
                            <a href="https://api.whatsapp.com/send/?phone=558632364215" target="_blank" rel="noopener noreferrer" className="hover:text-red-600 font-semibold block mb-2">(86) 98236-4215</a>
                            <span className="text-xs text-gray-500">Atendimento direto</span>
                        </p>
                    </div>
                </div>

                {/* Social Media Section */}
                <div className="bg-gradient-to-br from-red-600 to-red-700 rounded-xl p-8 text-white">
                    <h3 className="text-3xl font-bold mb-4 text-white">Nos Acompanhe nas Redes Sociais</h3>
                    <p className="text-red-100 mb-8 max-w-3xl">
                        Acompanhe as novidades e os conteúdos institucionais da Distribuidora York. Siga nossos canais e fique sempre atualizado!
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                        <a 
                            href="https://www.facebook.com/profile.php?id=100067954752927&locale=pt_BR"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center space-x-3 bg-white bg-opacity-10 hover:bg-opacity-20 p-4 rounded-lg transition duration-300 group/social"
                        >
                            <FaFacebook size={24} className="group-hover/social:scale-110 transition duration-300 flex-shrink-0" />
                            <span className="font-semibold">Facebook</span>
                        </a>

                        <a 
                            href="https://www.instagram.com/yorkdistribuidora?utm_medium=copy_link"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center space-x-3 bg-white bg-opacity-10 hover:bg-opacity-20 p-4 rounded-lg transition duration-300 group/social"
                        >
                            <FaInstagram size={24} className="group-hover/social:scale-110 transition duration-300 flex-shrink-0" />
                            <span className="font-semibold">Instagram</span>
                        </a>

                        <a 
                            href="https://www.linkedin.com/company/york-distribuidora-ltda"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center space-x-3 bg-white bg-opacity-10 hover:bg-opacity-20 p-4 rounded-lg transition duration-300 group/social"
                        >
                            <FaLinkedin size={24} className="group-hover/social:scale-110 transition duration-300 flex-shrink-0" />
                            <span className="font-semibold">LinkedIn</span>
                        </a>

                        <a 
                            href="https://api.whatsapp.com/send/?phone=558632364215&text&type=phone_number&app_absent=0"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center space-x-3 bg-white bg-opacity-10 hover:bg-opacity-20 p-4 rounded-lg transition duration-300 group/social"
                        >
                            <FaWhatsapp size={24} className="group-hover/social:scale-110 transition duration-300 flex-shrink-0" />
                            <span className="font-semibold">WhatsApp</span>
                        </a>
                    </div>

                    <div className="bg-white bg-opacity-10 backdrop-blur rounded-lg p-4 text-center">
                        <p className="text-sm text-red-100 mb-1">📞 Atendimento Disponível</p>
                        <p className="font-bold text-lg text-white">Segunda a Sexta • 8h às 18h</p>
                    </div>
                </div>

                {/* CTA */}
  
            </div>
        </section>
    )
}

export default ContactSection;
